var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbUpFilledIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3381_3312",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.500977,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3381_3312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 21.501H8V8.50098L15 1.50098L16.25 2.75098C16.3667 2.86764 16.4625 3.02598 16.5375 3.22598C16.6125 3.42598 16.65 3.61764 16.65 3.80098V4.15098L15.55 8.50098H21C21.5333 8.50098 22 8.70098 22.4 9.10098C22.8 9.50098 23 9.96764 23 10.501V12.501C23 12.6176 22.9875 12.7426 22.9625 12.876C22.9375 13.0093 22.9 13.1343 22.85 13.251L19.85 20.301C19.7 20.6343 19.45 20.9176 19.1 21.151C18.75 21.3843 18.3833 21.501 18 21.501ZM6 8.50098V21.501H2V8.50098H6Z",
    fill: "#0085FF",
    fillOpacity: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUpFilledIcon);
export default __webpack_public_path__ + "static/media/thumb-up-filled-icon.0d51bc251aa4b4d2ec03609fcdecb17e.svg";
export { ForwardRef as ReactComponent };